import React, { useContext } from 'react';
import { IAllForColumnX, IGalleryList, IOneGallery } from './Common';
import Column1 from './Column1';
import ImageUtil from '../../utils/image';
import { getWatermarks } from '../../utils/util';
import ReactSVG from 'react-svg';
import { ThemeContext } from '../../store/ThemeProvider';
import uColumn2List from './useColumn2List';
import RootStore from '../../store/RootStore';
import { inject, observer } from 'mobx-react';

interface IAllForColumn1 extends IAllForColumnX {
  isHot?: boolean;
  lazy?: boolean; 
  rootStore?: RootStore;
} 

// 注意， 我的相片也是用的这个组件哦
const AllForColumn1 = function(props: IAllForColumn1) {
  const { jigsaw } = props;

  const { galleryStore, wxuserStore } = props.rootStore!;
  const { currentPayedImages } = wxuserStore;

  return (
    <>  
      {
        props.list.map((one, index) => {
          const { hash, styleName, id, show_mark, galleryid, width, height} = one;
          return (
            <Column1
              id={id}
              key={id}
              index={index + 1}
              src={ImageUtil.style(
                hash,
                "wx_1920_n",
                {
                  width:Number(width),
                  height:Number(height),
                  watermark: galleryStore.getWatermarksByKey(
                    String(galleryid),
                    show_mark
                  ),
                },
                id
              )}
              onClick={()=>{
                props.onClick({id,index,galleryid});
              }}
              jigsaw={jigsaw}
            />
          );
        })
      }
    </>
  );
};
export default inject('rootStore')(observer(AllForColumn1));
